'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var sha3 = require("js-sha3");
var bytes_1 = require("./bytes");
function keccak256(data) {
    return '0x' + sha3.keccak_256(bytes_1.arrayify(data));
}
exports.keccak256 = keccak256;



//////////////////
// WEBPACK FOOTER
// ./~/ethers/utils/keccak256.js
// module id = RxTX
// module chunks = 0